export default ({ $auth, redirect }) => {
  const isAdminOrCurator =
    $auth.$state.user &&
    ($auth.$state.user.isAdmin || $auth.$state.user.role === 'Curator')
  if (!isAdminOrCurator) return redirect('/')
}
